import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MenuBarComponent } from './components/menu-bar/menu-bar.component';
import { FieldInputErrorComponent } from './components/form-error/field-input-error.component';
import { AlertComponent } from './components/alert/alert.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// import { GlobalErrorHandler } from './components/errors/global-error-handler';
import { HttpLoadingInterceptor } from './components/errors/http-loading.interceptor';
import { SharedModule } from '../shared/shared.module';
import { JsonViewComponent } from './json-view/json-view.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { UsersListComponent } from './components/user-management/users-list/users-list.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ValidationsDialogComponent } from './components/validations-dialog/validations-dialog.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    HeaderComponent,
    MenuBarComponent,
    LoginComponent,
    FieldInputErrorComponent,
    AlertComponent,
    JsonViewComponent,
    SignUpComponent,
    UsersListComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    ValidationsDialogComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, RouterModule],

  exports: [HeaderComponent, MenuBarComponent, FieldInputErrorComponent],
  providers: [
    // {
    //   provide: ErrorHandler,
    //   useClass: GlobalErrorHandler,
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoadingInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {}
